/* eslint-disable no-console */
import axios, {AxiosError} from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';
interface ErrorResponse {
  message: string;
}

const assignPermissionExternal = async (data?: any): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const company = useCompanyStore.getState().companyId;
  const roleTypes = useJSONStore.getState().roleTypes;
  const accessTypes = useJSONStore.getState().accessTypes;
  const role = roleTypes.find((item) => item.name === data.roles);
  const access = accessTypes.find(
    (item) => item.description === data.selectedAccess
  );

  const body = {
    users:
      data?.addMemberForms?.map((item: any) => ({
        firstName: item.firstName,
        lastName: item.lastName,
        mobile: item.phoneNumber,
        email: item.emailAddress
      })) || [],
    userGroupId: data.selectedUserGroup,
    userType: data.roles,
    company,
    permissions: data.permissions,
    roles: [role.id, access.id],
    roleNames: [role.name, access.name],
    parentId: data.selectedAdmin
  };

  try {
    const res = await axios.request({
      method: CRUDMethods.POST,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.assignPermissionExternal}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: body
    });

    return res.data;
  } catch (err: any) {
    const reloadSubscription = err?.response?.data?.reloadSubscription;
    if (reloadSubscription) {
      const data = err?.response?.data;
      const message = data?.message || 'Something went wrong';
      const reloadSubscription = data?.reloadSubscription === true;
      const reloadType = data?.reloadType;

      return {status: 'error', message, reloadSubscription, reloadType};
    }
    const axiosError = err as AxiosError;
    if (axiosError.response) {
      const responseData = axiosError.response.data as ErrorResponse;

      return {
        status: 'error',
        message: responseData.message || 'An error occurred'
      };
    }

    return {
      status: 'error',
      message: axiosError.message || 'An error occurred'
    };
  }
};

export default assignPermissionExternal;
